/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Bank_RecordedInputs */

const vi_cashflow_bank_recorded = /** @type {(inputs: Cashflow_Bank_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã ghi nhận (CK)`)
};

/**

* @param {Cashflow_Bank_RecordedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_bank_recorded = /** @type {((inputs?: Cashflow_Bank_RecordedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Bank_RecordedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_bank_recorded(inputs)
});